import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import _ from 'lodash';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
    root: props => ({
        cursor: 'grab',
        display: props.options?.isVisible ? 'block' : 'none',
        marginBottom: -5,
        width: '100%'
    }),
    image: {
        height: 'auto',
        width: '100%'
    },
    slider: props => ({
        '& .slick-dots': {
            display: "block!important",
            bottom: 10,
            '& li button:before': {
                color: `${props.options?.pagerColor}!important`,
                opacity: 1
            },
            '& li.slick-active button:before': {
                color: `${props.options?.activePagerColor}!important`,
            }
        }
    })
}));

export default function PromotionalBanner() {
    const data = useSelector(state => state.ThemeReducer.settings.find(s => s.key === 'promotionalBanner'));
    const classes = useStyles(data);

    if (data?.options?.isVisible) {
        return (
            <div className={classes.root}>
                <Slider
                    autoplay={data?.options?.autoplay}
                    autoplaySpeed={parseInt(_.get(data, 'options.autoplaySpeed', 2000))}
                    className={classes.slider}
                    dots={data?.options?.showPager}

                    // We are setting the key like this to force the component to rerender when 
                    // autoplay changes, otherwise the autoplay dynamically selection will not work
                    key={data?.options?.autoplay}
                >
                    {data?.content?.map((banner, index) => {
                        return <img key={`banner-${index}`} src={banner.url ? banner.url : require('../../Editor/_assets/images/image_placeholder_800_100.png')} className={classes.image} alt="banner" />
                    })}
                </Slider>
            </div>
        );
    } else {
        return <></>
    }
}